import { localStorage } from 'react-storage'
import { createPersistentStorage } from '@src/utils/createPersistentStorage'
import { TrackingDataTypes } from '@src/utils/useTypedUserActivity'

export enum InviteCoWorkerWalkMeConstants {
  BANNER_ID = 'walkme-banner',
  DISMISSED_KEY = 'walkme.dismissedWalkMe',
  MAX_DISMISSALS = 4,
  TRACKING_DATA_KEY = 'WALK_ME_INVITE_COWORKER_RESULTS',
}

const searchResultStorage = createPersistentStorage<
  TrackingDataTypes[typeof InviteCoWorkerWalkMeConstants.TRACKING_DATA_KEY]
>(localStorage, InviteCoWorkerWalkMeConstants.TRACKING_DATA_KEY, 'v1')

export const getInviteCoWorkerStorageOverride = (userIsLoggedIn: boolean) => {
  return userIsLoggedIn ? undefined : searchResultStorage
}
